__turbopack_context__.v({
  "badge": "InteractiveBadge-module-scss-module__IGR4sW__badge",
  "bump": "InteractiveBadge-module-scss-module__IGR4sW__bump",
  "core": "InteractiveBadge-module-scss-module__IGR4sW__core",
  "ring": "InteractiveBadge-module-scss-module__IGR4sW__ring",
  "ripple": "InteractiveBadge-module-scss-module__IGR4sW__ripple",
  "spin": "InteractiveBadge-module-scss-module__IGR4sW__spin",
  "thump": "InteractiveBadge-module-scss-module__IGR4sW__thump",
});
